export const OPEN_IN_BROWSER_QUERY_PARAM: string = 'openInBrowser';

export const OPEN_IN_BROWSER_QUERY_VALUE: string = 'true';
